import { FC, useCallback } from 'react';
import { Button, Tag } from 'tedooo-web-design-system/ui';

import Section from 'components/section/Section';
import { IProduct, Sections, ICatalogSection } from 'types';
import CatalogItem from 'pages/shopPage/catalogItem/CatalogItem';
import './catalogSection.scss';
import { translations } from 'translations/en';

const CatalogSection: FC<ICatalogSection> = ({
  list,
  shopId,
  isShopOwner,
  onEmptyStateButtonClick,
  onSeeAllCatalogClick,
  onPreviewClick,
  hasNewItems,
  onEditCatalogItemClick,
  onDuplicateCatalogItemClick,
  onDeleteCatalogItemClick,
  onSaveItemClick,
}) => {
  const itemContent = useCallback(
    (item: IProduct, index: number) => (
      <CatalogItem
        key={item.id}
        id={item.id}
        index={index}
        isDraggable={false}
        image={item.images[0]}
        quantity={item.quantity}
        shippingInformation={item.shippingInformation}
        isDigital={item.isDigital}
        price={item.price}
        originalPrice={item.originalPrice}
        isLiked={item.isLiked}
        totalLikes={item.totalLikes}
        currencyCode={item.currencyCode}
        name={item.title}
        onClick={onPreviewClick}
        isShopOwner={isShopOwner}
        onLikeToggle={() => onSaveItemClick(item.id, item.isLiked)}
        onEditClick={() => onEditCatalogItemClick(item.id)}
        onDuplicateClick={() => onDuplicateCatalogItemClick(item.id)}
        onDeleteClick={() => onDeleteCatalogItemClick(item.id)}
      />
    ),
    [shopId],
  );

  const tag = hasNewItems ? (
    <Tag color="purple" size="medium" text={translations.COMMON.NEW_ITEMS} />
  ) : undefined;

  let emptyStateButton;
  if (isShopOwner) {
    emptyStateButton = (
      <Button
        type="primary"
        size="medium"
        borderRadius="small"
        onClick={onEmptyStateButtonClick}
        text={translations.SHOP.CATALOG_EMPTY_STATE_BUTTON}
      />
    );
  }

  return (
    <Section
      className="catalog"
      itemContent={itemContent}
      list={list}
      type={Sections.Catalog}
      onButtonClick={onSeeAllCatalogClick}
      tag={tag}
      emptyStateButton={emptyStateButton}
    />
  );
};

export default CatalogSection;
